import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { DepositType } from '@/api';
import { LinkButton } from '@/components/buttons';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { QueryParams } from '@/constants/QueryParam';
import { routeMap } from '@/routes/routeMap';
import { constructURL } from '@/utils/url';

type Payload = {
  depositAmount: number;
  depositType: DepositType;
};
type Props = ModalProps<Payload>;

const DepositFail = ({ closeModal, payload }: Props) => {
  const { t } = useTranslation('Modal');
  const { depositAmount, depositType } = payload;

  return (
    <Modal title={t('DepositFail.title')}>
      <p>{t('DepositFail.info')}</p>
      <ModalActions>
        <LinkButton
          to={constructURL(routeMap.credit.deposit.UK.summary, {
            relative: true,
            queryParams: {
              [QueryParams.DEPOSIT_AMOUNT]: String(depositAmount),
              [QueryParams.DEPOSIT_TYPE]: depositType,
            },
          })}
          onClick={closeModal}
        >
          {t('DepositFail.tryAgain')}
        </LinkButton>
        <LinkButton
          variant="secondary"
          to={constructURL(routeMap.credit.deposit.UK.summary, {
            relative: true,
            queryParams: {
              [QueryParams.DEPOSIT_AMOUNT]: String(depositAmount),
              [QueryParams.IS_MANUAL_DEPOSIT]: 'true',
            },
          })}
          onClick={closeModal}
        >
          {t('DepositFail.payManually')}
        </LinkButton>
      </ModalActions>
    </Modal>
  );
};

export default DepositFail;
